import { Component, OnInit } from '@angular/core';
import { BlockLifeChanges, BlockType, StepData } from '@shared/models/step.model';
import { EntityStatus } from '@shared/models/menu.model';
import { CourseContentService, ShortCodes } from '@app/courseContent/courseContent.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';

export const LIFE_CHANGE_SHORTCODE: string = 'lifeChanges';

@Component({
  selector: 'pl-life-changes',
  templateUrl: './myLifeChanges.component.html',
})
export class MyLifeChangesComponent implements OnInit {
  public isLoading: boolean = false;

  public mockBlockLifeChanges: BlockLifeChanges | null = null;

  constructor(private courseContentService: CourseContentService) {}

  public async ngOnInit(): Promise<void> {
    this.isLoading = true;
    const lifeChangeShortCodeValue: string | null = await this.retrieveLifeChanges();
    this.mockBlockLifeChanges = this.getMockBlockLifeChanges(lifeChangeShortCodeValue);
    this.setMockStepDataWithinCourseContentService(this.mockBlockLifeChanges);
    this.isLoading = false;
  }

  private setMockStepDataWithinCourseContentService(blockLifeChanges: BlockLifeChanges): void {
    const mockStepData: StepData = {
      id: -1, // this value does not matter here, it's not going to be used
      title: '',
      name: '',
      description: '',
      congrats: '',
      hideStepInMenu: true,
      breadcrumbs: '',
      prev_page_url: '',
      next_page_url: '',
      fullUrl: getRoutePath(PlRoute.lifeChanges),
      slug: getRoutePath(PlRoute.lifeChanges),
      status: EntityStatus.current,
      blocks: [blockLifeChanges],
    };
    this.courseContentService.setCurrentStepData(mockStepData);
  }

  public async retrieveLifeChanges(): Promise<string | null> {
    const shortcodes: ShortCodes = await this.courseContentService.getShortcodes([LIFE_CHANGE_SHORTCODE]);
    return shortcodes[LIFE_CHANGE_SHORTCODE] as string | null;
  }

  private getMockBlockLifeChanges(lifeChangeShortCodeValue: string | null): BlockLifeChanges {
    return {
      id: -1, // this value does not matter here, it's not going to be used
      element: BlockType.lifeChanges,
      source_program_data_code: null,
      program_data_code: LIFE_CHANGE_SHORTCODE,
      data: {
        value: lifeChangeShortCodeValue,
      },
    };
  }
}
